import React from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import { CopyToClipboard, concatString } from "@_common/text-helpers";
import DragAndDropFileComponent from "@_common/file-drag-drop";
import { handleDownloadOnClick } from "@_common/downloadfile";

function UserGuideEditPopup(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    request,
    handleChangeText,
    submitLoading,
    handleSubmit,
    editId,
    setRequest,
    uploadLoading
  } = props;
  return (
    <div
      className={`compelte-task-wrapper compelte-task-wrapper-add ${
        showUpdatePopup ? "compelte-task-wrapper--active" : ""
      }`}
    >
      <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
        <h6 className="compelte-task-wrapper__title">User Guide</h6>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={() => {
            setShowUpdatePopup(false);
          }}
        />
      </div>

      {/* <div className="compelte-task-wrapper__body d-flex h-100"></div> */}
      <div className="w-100 max-height-mail-template email-template-wrapper">
        <div className="user-details-wrapper m-0 email-template-editable-content-holder">
          <div className="email-template-editable-content">
            <div className="checkpoint-active-details-wrapper__form-wrapper">
              <div className="checkpoint-active-details-wrapper__form-content_email_template">
                {/* <h4 className="mt-3 mb-3">New task assigned)</h4> */}
                <div className="modal-grid">
                  <div className="user-details-wrapper__form-group form-group">
                    <label className="checkpoint-active-details__label form-label-error">
                      Guide Type <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-center">
                        <input
                          type="radio"
                          className="form-radio"
                          checked={
                            getValue(request, `type`, "") === "video"
                              ? true
                              : false
                          }
                          onChange={() =>
                            setRequest({ ...request, type: "video" })
                          }
                          id="video"
                        />
                        <label htmlFor="video" className="ms-2 mb-0">
                          Video
                        </label>
                      </div>
                      <div className="d-flex align-items-center mt-1 ms-3">
                        <input
                          type="radio"
                          className="form-radio"
                          checked={
                            getValue(request, `type`, "") === "document"
                              ? true
                              : false
                          }
                          onChange={() =>
                            setRequest({ ...request, type: "document" })
                          }
                          id="document"
                        />
                        <label htmlFor="document" className="ms-2 mb-0">
                          Document
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="user-details-wrapper__form-group form-group">
                    <label className="checkpoint-active-details__label">
                      Title <span className="text-danger">*</span>
                    </label>
                    <InputField
                      inputType="TEXT"
                      placeholder="Enter Title"
                      className="form-control w-100"
                      name="name"
                      id="name"
                      value={getValue(request, `name`, "")}
                      onChange={(e: any) => handleChangeText(e)}
                      label="name"
                      // validator={simpleValidator}
                    />
                  </div>

                  <div className="user-details-wrapper__form-group form-group add-user-guide-desc">
                    <label className="checkpoint-active-details__label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <InputField
                      inputType="TEXTAREA"
                      placeholder="Enter Description"
                      className="form-control w-100"
                      name="description"
                      id="description"
                      value={getValue(request, `description`, "")}
                      onChange={(e: any) => handleChangeText(e)}
                      label="Description"
                      // validator={simpleValidator}
                    />
                  </div>
                  {getValue(request, `type`, "") === "video" ? (
                    <div
                      className="user-details-wrapper__form-group form-group"
                      id="video_url_wrap"
                    >
                      <label className="checkpoint-active-details__label">
                        Video URL <span className="text-danger">*</span>
                      </label>
                      <InputField
                        inputType="TEXT"
                        placeholder="Enter Video URL"
                        className="form-control w-100"
                        name="video_url"
                        id="video_url"
                        value={getValue(request, "video_url", "")}
                        onChange={handleChangeText}
                        label="video_url"
                        // validator={simpleValidator}
                      />
                    </div>
                  ) : (
                    <div
                      className="user-details-wrapper__form-group form-group"
                      id="document_url_wrap"
                    >
                      <label className="checkpoint-active-details__label">
                        Upload Document <span className="text-danger">*</span>
                      </label>
                      <DragAndDropFileComponent
                        uploadFile={props.handleUploadDocuments}
                        name="file"
                        // types={fileTypes}
                        classes="bulk-upload_drag-n-drop-wrapper position-absolute"
                      />
                      {getValue(request, `document.name`, "") && (
                        <div className="compelte-task-wrapper__uploaded-files mt-2">
                          <ul>
                            <li
                              className="compelte-task-wrapper__uploaded d-flex align-items-center justify-content-between cursor-pointer"
                              onClick={() =>
                                handleDownloadOnClick(
                                  getValue(request, `document.url`, ""),
                                  getValue(request, `document.name`, "")
                                )
                              }
                            >
                              <span>
                                {concatString(
                                  getValue(request, `document.name`, ""),
                                  20
                                )}
                                {getValue(request, `document.extension`, "")}
                              </span>

                              {/* {!editId && ( */}
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setRequest({
                                      ...request,
                                      document: "",
                                    });
                                  }}
                                >
                                  <img src="/images/close-black.svg" />
                                </div>
                              {/* )} */}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="compelte-task-wrapper__cta d-flex align-items-center">
            <button
              className="ascent-button ascent-button--primary"
              onClick={() => {
                setShowUpdatePopup(false);
                props.setEditId("");
              }}
            >
              Cancel
            </button>
            <button
              className="ascent-button ascent-button--secondary"
              onClick={() => handleSubmit()}
              disabled={submitLoading || uploadLoading}
              >
              {submitLoading || uploadLoading ? "Please wait..." : editId ? "Update" : "Create"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserGuideEditPopup;
